// extracted by mini-css-extract-plugin
export var checkboxWrapper = "index-module--checkboxWrapper--VYQdy";
export var headerContainer = "index-module--headerContainer--22Y+k";
export var iconChecked = "index-module--iconChecked--djHa9";
export var iconNormal = "index-module--iconNormal--PHdSb";
export var tagContainer = "index-module--tagContainer--QPjqc";
export var tagList = "index-module--tagList--qs9pW";
export var tipArea = "index-module--tipArea--b5wbM";